/** @type {import('@lingui/conf').LinguiConfig} */
module.exports = {
  locales: [
    'en',
    'es',
    'pt-br',
    'ar',
    'de',
    'cs',
    'sk',
    'hr',
    'pl',
    'hu',
    'ro',
    'bg',
    'tr',
    'it',
    'fr',
  ],
  sourceLocale: 'en',
  catalogs: [
    {
      path: '<rootDir>/src/locales/{locale}/messages',
      include: ['src'],
    },
  ],
  // Keep this file import-free: the browser bundle and the islands build load it, the latter without
  // frontend/node_modules. The CLI's default format is PO.
};
